import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css";
import api from "../../../api";

export const Login = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const salesPersonId = localStorage.getItem("salesPersonId");

    if (salesPersonId) {
      navigate("/landing", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async () => {
    if (!username.trim() || !password.trim()) {
      setError("Please enter both username and password.");
      setTimeout(() => setError(""), 3000);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await api.post("/api/login", {
        username,
        password,
      });

      if (res.data?.errCode == -3) {
        setError(res.data?.errMsg || "Invalid username or password.");
        setTimeout(() => setError(""), 4000);
        return;
      }

      const salesPersonId = res.data?.data?.SalesPersonId;

      localStorage.setItem(
        "salesPersonId",
        salesPersonId !== null && salesPersonId !== undefined
          ? String(salesPersonId)
          : null
      );

      navigate("/landing");
    } catch (e) {
      setError(
        e.response?.data?.message || "Invalid username or password."
      );
      setTimeout(() => setError(""), 4000);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="loginMain">
      <div className="loginHeader">
        <div className="loginHeaderLeft">
          <div className="loginLogoBox">
            <span className="material-symbols-outlined">pie_chart</span>
          </div>
          <p className="loginAppName">Alpap CRM</p>
        </div>
      </div>

      <div className="loginBody">
        <div className="loginCard">
          <div className="loginSecurePill">
            <span className="material-symbols-outlined loginSecureIcon">
              security
            </span>
            <span className="loginSecureText">Secure access</span>
          </div>

          <div className="loginTitleGroup">
            <p className="loginTitle">Sign in to Alpap CRM</p>
            <p className="loginSubtitle">
              Use your username and password to access your dashboard.
            </p>
          </div>

          <div className="loginFieldGroup">
            <p className="loginFieldLabel">Username</p>
            <div className="loginInputWrapper">
              <input
                className="loginInput"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={handleKeyDown}
                autoComplete="username"
              />
              <span className="material-symbols-outlined loginInputIcon">
                person
              </span>
            </div>
          </div>

          <div className="loginFieldGroup">
            <p className="loginFieldLabel">Password</p>
            <div className="loginInputWrapper">
              <input
                className="loginInput"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
                autoComplete="current-password"
              />
              <span
                className="material-symbols-outlined loginInputIcon loginPasswordToggle"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "visibility_off" : "visibility"}
              </span>
            </div>
          </div>

          {error && <p className="loginError">{error}</p>}

          <button
            className="loginSubmitBtn"
            onClick={handleSubmit}
            disabled={loading}
          >
            <span className="material-symbols-outlined loginSubmitIcon">
              login
            </span>
            {loading ? "Signing in..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};